<odx-card class="container" (interact)="onClick()" variant="default">
  <span class="overflow">{{ project.customer.name }}</span>
  @if (isMonitoringScope()) {
    <h6 class="odx-subtitle-6">
      {{ draegerContactPerson() }}
    </h6>
  }
  <odx-card-content>
    <h5 class="odx-title-4 overflow">
      {{ project.name }}
    </h5>
    <h5 class="odx-subtitle-5">
      {{ project.placeName }}
    </h5>
    <div class="odx-title-4 overflow">
      <odx-chip removable="false" size="small" variant="secondary" i18n="@@projectCard.projectStatus" class="chip">
        <odx-icon [name]="statusIcon$ | async" alignleft></odx-icon>
        {{ project.status }}
      </odx-chip>

      @if (isCollaborationProject) {
        <odx-chip class="chip" removable="false" size="small" variant="highlight" i18n="@@projectCard.collaborationProject">
          <odx-icon name="user-group" alignleft></odx-icon>
          Kollaborationsprojekt
        </odx-chip>
      }
    </div>
  </odx-card-content>
  <odx-card-footer (click)="onClick()">
    <p class="odx-text--small status-text">
      <odx-icon name="save" inline></odx-icon>
      <span i18n="@@projectCard.lastModified">
        Letzte Änderung:
        {{ project.lastModified | localizeDate }} um
        {{ project.lastModified | localizeTime }}
      </span>
    </p>
    <p class="odx-text--small status-text cloud-save">
      <odx-icon name="cloud" inline></odx-icon>
      <span i18n="@@projectCard.lastSynced.prefix"> Letzte Cloud Synchronisierung: </span>
      @if (project.lastCloudSync) {
        <span i18n="@@projectCard.lastSynced.dateAndTime">
          {{ project.lastCloudSync | localizeDate }} um
          {{ project.lastCloudSync | localizeTime }}
        </span>
      }
      @if (!project.lastCloudSync) {
        <span i18n="@@projectCard.lastSynced.never">-- </span>
      }
    </p>
  </odx-card-footer>

  @if (showMenu) {
    <odx-menu [odxTooltip]="offlineToolTipMessage">
      <button odxButton odxMenuItem (click)="$event.stopPropagation(); exportProjectToPdf(project)">
        <odx-icon name="file-pdf" alignleft></odx-icon>
        <span i18n="@@projectCard.button.exportToPdf">Projekt als PDF exportieren</span>
      </button>
      <button
        odxButton
        odxMenuItem
        [disabled]="!navigator.onLine || (hasWritePermission$ | async) === false"
        (click)="$event.stopPropagation(); openInvitePersonModal()"
      >
        <odx-icon name="user-add" alignleft></odx-icon>
        <span i18n="@@projectCard.button.invitePersonToProject">Person zu dem Projekt einladen</span>
      </button>
      <button
        odxButton
        odxMenuItem
        [disabled]="!navigator.onLine || (hasWritePermission$ | async) === false"
        (click)="$event.stopPropagation(); openShareLinkModal()"
      >
        <odx-icon name="mail" alignleft></odx-icon>
        <span i18n="@@projectCard.button.shareProjectLink">Lesefreigabe erteilen</span>
      </button>
      <button odxButton odxMenuItem (click)="$event.stopPropagation(); onDelete()" data-testid="btn.deleteProject">
        <odx-icon name="delete" alignleft></odx-icon>
        <span i18n="@@projectCard.button.deleteProject">Projekt löschen</span>
      </button>
    </odx-menu>
  }
</odx-card>
